import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'country-aquaculture-policies',
  templateUrl: './country-aquaculture-policies.component.html',
  styleUrls: ['./country-aquaculture-policies.component.scss']
})
export class CountryAquaculturePoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
